import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { getAppHeader } from "../../../configs/config";
import { api } from "../../../configs/api";
import { InputStateToken } from "@voltmoney/schema";
import { Platform } from 'react-native';
export const goBack = async (action, _datastore, { goBack, navigateWithClear }) => {
    const isFromForeclosureRasonPage = action?.payload?.isFromForeclosureRasonPage;
    const showNewForeclosure = action?.payload?.showNewForeclosure;
    if (showNewForeclosure === true && isFromForeclosureRasonPage === true && Platform.OS === 'ios') {
        await navigateWithClear(ROUTE.FORECLOSURE_REASON);
    }
    else
        await goBack();
};
export const fetchCollaterals = async (action, _datastore, { goBack, navigate, network }) => {
    const user = await SharedPropsService.getUser();
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
    };
    const creditResponse = await network
        .get(`${api.getCollateral}${user?.linkedCredits[0]?.creditId}`, requestOptions);
    if (creditResponse.status === 200) {
        const creditData = creditResponse.data;
        await navigate(ROUTE.FORECLOSURE_COLLATERAL_DETAILS, { creditData });
    }
};
let counter = 0;
export const verifyOtp = async (action, _datastore, { network, setDatastore, navigate }) => {
    const otp = action?.payload?.otp;
    const user = await SharedPropsService.getUser();
    await setDatastore(action.routeId, "confirmLoanDetails", {
        state: InputStateToken.DEFAULT,
        counter: Math.random(),
    });
    const response = await network.post(`${api.verifyForeclosure}`, {
        otp: otp,
        phoneNo: user?.user?.phoneNumber
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            otpModal: false,
            counter: Math.random(),
        });
        await navigate(ROUTE.DASHBOARD);
    }
    else {
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "confirmLoanDetails", {
                state: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                counter: Math.random(),
            });
        }
        else {
            await setDatastore(action.routeId, "confirmLoanDetails", {
                state: InputStateToken.ERROR,
                caption: { error: response.response.data.message },
                counter: Math.random(),
            });
        }
    }
};
export const resendOtp = async (action, _datastore, { network, navigate, setDatastore }) => {
    const user = await SharedPropsService.getUser();
    const creditId = user?.linkedCredits[0].creditId;
    const customerReason = await SharedPropsService.getCustomerReason();
    const customerReasonRemark = await SharedPropsService.getCustomerRemarks();
    const response = await network.post(`${api.initiateForeclosure}`, {
        creditId: creditId,
        customerReason: customerReason ? customerReason : null,
        customerReasonRemark: customerReasonRemark ? customerReasonRemark : null,
    }, {
        headers: await getAppHeader(),
        handleFromMF: true,
    });
    if (response?.status === 200) {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: false,
            otpModal: true,
            errorTitle: '',
            errorMessage: '',
            counter: Math.random(),
        });
    }
    else if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: true,
            otpModal: false,
            errorTitle: 'OTP Attempts Exceeded',
            errorMessage: response?.response?.data?.message,
            counter: Math.random(),
        });
    }
    else {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: true,
            otpModal: false,
            errorTitle: 'Verification failed!',
            errorMessage: 'Something went wrong',
            counter: Math.random(),
        });
    }
};
export const continueAction = async (action, _datastore, { network, navigate, setDatastore, instrumentTrack }) => {
    await instrumentTrack('CONFIRM_OTP_BUTTON_CLICKED');
    await setDatastore(action.routeId, "confirmLoanDetails", {
        state: InputStateToken.DEFAULT,
        errorModal: false,
        otpModal: false,
        errorTitle: '',
        errorMessage: '',
        counter: Math.random(),
    });
    const user = await SharedPropsService.getUser();
    const creditId = user?.linkedCredits[0].creditId;
    const customerReason = await SharedPropsService.getCustomerReason();
    const customerReasonRemark = await SharedPropsService.getCustomerRemarks();
    const response = await network.post(`${api.initiateForeclosure}`, {
        creditId: creditId,
        customerReason: customerReason ? customerReason : null,
        customerReasonRemark: customerReasonRemark ? customerReasonRemark : null,
    }, {
        headers: await getAppHeader(),
        handleFromMF: true,
    });
    if (response?.status === 200) {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: false,
            otpModal: true,
            errorTitle: '',
            errorMessage: '',
            counter: Math.random(),
        });
    }
    else if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: true,
            otpModal: false,
            errorTitle: 'OTP Attempts Exceeded',
            errorMessage: response?.response?.data?.message,
            counter: Math.random(),
        });
    }
    else if (response.response.data.voltErrorCode === "BAD_REQUEST_INVALID_INPUT") {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: true,
            otpModal: false,
            errorTitle: 'Verification failed!',
            errorMessage: response?.response?.data?.message,
            counter: Math.random(),
        });
    }
    else {
        await setDatastore(action.routeId, "confirmLoanDetails", {
            errorModal: true,
            otpModal: false,
            errorTitle: 'Verification failed!',
            errorMessage: 'Something went wrong',
            counter: Math.random(),
        });
    }
};
export const handleCloseOtpModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, "confirmLoanDetails", {
        state: InputStateToken.DEFAULT,
        counter: Math.random(),
    });
};
